import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungPforzheim() {
  return (
    <CityPageTemplate
      city="Pforzheim"
      slug="pforzheim"
      intro="Pforzheim als Goldstadt – wir helfen Dir, Dein eigenes finanzielles Gold aufzubauen."
      description="Unabhängige & digitale Finanzberatung für Pforzheim: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
